<template>
  <BaseFiltersSideBar
    v-model="model"
    @filters-submit="onFiltersSubmit"
  >
    <CertificationsListFiltersForm
      ref="certifications-list-filters-form"
      v-model="filters"
      @submit="onFiltersSubmit"
    />
  </BaseFiltersSideBar>
</template>

<script>
import BaseFiltersSideBar from '@/components/ui/sidebar/BaseFiltersSideBar.vue'
import CertificationsListFiltersForm from '@/components/certifications/form/CertificationsListFiltersForm.vue'

export default {
  name: 'CertificationsListFilters',
  components: {
    CertificationsListFiltersForm,
    BaseFiltersSideBar,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      filters: {},
    }
  },
  computed: {
    model: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      },
    },
  },
  methods: {
    clearFilters() {
      this.$refs['certifications-list-filters-form'].clearForm()
    },
    onFiltersSubmit() {
      this.model = false
      this.$emit('filters-submit', this.filters)
    },
  },
}
</script>

<style lang="scss">
</style>
